import {
  NgModule,
  Inject
} from '@angular/core';
import { FormsSources } from './forms-sources';
import { FormsRunner } from './forms-runner';
import { ROOT_FORMS } from './tokens';
import { NGXLogger } from 'ngx-logger';
import { AbstractFormDefinition } from './abstract-form-definition';

@NgModule({})
export class DxFormsRootModule {
  constructor(
    private sources: FormsSources,
    runner: FormsRunner,
    @Inject(ROOT_FORMS) rootForms: any[],
    logger: NGXLogger
  ) {
    logger.trace('[DxFormsRootModule::constructor] call');
    runner.start();

    rootForms.forEach(formsSourceInstance =>
      this.sources.addForm(formsSourceInstance)
    );
  }

  addForm(formDefinition: AbstractFormDefinition<any>) {
    this.sources.addForm(formDefinition);
  }

}
